// Npm
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';

export const formatMessageHOC =
  (Component: any) =>
    (props: any): ReactElement => {
    // get the internalization module & format message in destructure
      const { formatMessage: f } = useIntl();

      // append the format message function into the props
      const formatMessageProps = { ...props, f };

      //return the parent component with props
      return <Component {...formatMessageProps} />;
    };
